var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2439_16275",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2439_16275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66669 12.5C3.55558 12.5 2.61113 12.1111 1.83335 11.3333C1.05558 10.5556 0.666687 9.61111 0.666687 8.5C0.666687 7.38889 1.05558 6.44444 1.83335 5.66667C2.61113 4.88889 3.55558 4.5 4.66669 4.5H11.3334C12.4445 4.5 13.3889 4.88889 14.1667 5.66667C14.9445 6.44444 15.3334 7.38889 15.3334 8.5C15.3334 9.61111 14.9445 10.5556 14.1667 11.3333C13.3889 12.1111 12.4445 12.5 11.3334 12.5H4.66669ZM4.66669 11.1667H11.3334C12.0667 11.1667 12.6945 10.9056 13.2167 10.3833C13.7389 9.86111 14 9.23333 14 8.5C14 7.76667 13.7389 7.13889 13.2167 6.61667C12.6945 6.09444 12.0667 5.83333 11.3334 5.83333H4.66669C3.93335 5.83333 3.30558 6.09444 2.78335 6.61667C2.26113 7.13889 2.00002 7.76667 2.00002 8.5C2.00002 9.23333 2.26113 9.86111 2.78335 10.3833C3.30558 10.9056 3.93335 11.1667 4.66669 11.1667ZM11.3334 10.5C11.8889 10.5 12.3611 10.3056 12.75 9.91667C13.1389 9.52778 13.3334 9.05556 13.3334 8.5C13.3334 7.94444 13.1389 7.47222 12.75 7.08333C12.3611 6.69444 11.8889 6.5 11.3334 6.5C10.7778 6.5 10.3056 6.69444 9.91669 7.08333C9.5278 7.47222 9.33335 7.94444 9.33335 8.5C9.33335 9.05556 9.5278 9.52778 9.91669 9.91667C10.3056 10.3056 10.7778 10.5 11.3334 10.5Z",
    fill: "#9CA3AF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleActivity);
export default __webpack_public_path__ + "static/media/toggle_activity.e36315c55a974fb189edd484a5321749.svg";
export { ForwardRef as ReactComponent };